var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({padding: '10px'})},[_c('div',[_vm._v("**** "+_vm._s(_vm.item.type)+" ****")]),_c('div',[_vm._v(_vm._s(_vm.layer1))]),_vm._l((_vm.item.contents),function(itm,i){return _c('SelectorEdit',{key:i,style:({marginLeft: '40px'}),attrs:{"item":itm}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }